module.exports = __webpack_public_path__ + "img/portfolio-04.e2349e95.jpg";